/* eslint-disable react/prop-types */
import React, { useState } from 'react'
import StyleGuide from '@taglivros/oef_componentes/build/components/styleGuide'
import { ReactComponent as Search } from '../../../assets/icons/search.svg'
import { ReactComponent as BlackArrow } from '../../../assets/icons/black-arrow.svg'

import Modal from '@taglivros/oef_componentes/build/components/modal'
import styled from 'styled-components'
import Button from '@taglivros/oef_componentes/build/components/button'
import moment from 'moment'
import { ReactComponent as XIcon } from '../../../assets/icons/x.svg'

const FilterContainer = styled.div`
  .header {
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 10px;
    font-weight: 600;
    color: #53586f;
    font-size: 18px;
    line-height: 20px;
    svg path {
      stroke: #009bbf;
    }
    @media (max-width: ${StyleGuide.mediaQuery.mobile}) {
      padding: 10px 20px 10px 10px !important;
      justify-content: space-between;
    }
  }
  .svg-filtrar {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  .background {
    border-radius: 8px;
    padding: 10px;
    background: #ffffff;
    box-shadow: 0px 1px 4px rgb(19 26 45 / 20%);
    width: 175px;
    margin-bottom: 20px;
    @media (max-width: 520px) {
      width: calc(100vw - 50px);
    }
  }
  .arrow {
    display: none;
    @media (max-width: ${StyleGuide.mediaQuery.mobile}) {
      display: unset;
      svg {
        cursor: pointer;
        transform: ${( { expanded } ) => expanded ? 'rotate(-180deg)' : 'rotate(0deg)'};
        transition: transform 0.2s;
      }
    }
  }
   .title {
    color: #53586f;
    font-weight: 600;
    font-size: 13px;
    line-height: 16px;
    padding;
  }
  .X {
    position: absolute;
    top: 24px;
    right: 20px;
    cursor: pointer;
  }
`

const ModalContainer = styled.div`
  .card--modal {
    padding: 15px;
    align-items: start;
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  .title {
    color: #53586f;
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;
    padding;
  }
  .year-buttons {
      /* gap: 15px */
      width: 100%;
      display: flex;
      justify-content: space-around;
  }
  .button-100w {
      width: 100%;
      button {
          width: 100%;
      }
  }
  @media (max-width: ${StyleGuide.mediaQuery.mobile}) {
    display: none;
  }
`

const Select = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
  span {
    color: #53586f;
    font-weight: bold;
    font-size: 18px;
    line-height: 24px;
  }
  svg:nth-child(1) {
    transform: rotate(90deg);
    cursor: pointer;
  }
  svg:nth-child(3) {
    transform: rotate(-90deg);
    cursor: pointer;
  }
  .noselect {
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
    -khtml-user-select: none; /* Konqueror HTML */
    -moz-user-select: none; /* Old versions of Firefox */
    -ms-user-select: none; /* Internet Explorer/Edge */
    user-select: none;
  }
`

const Year = styled.button`
  background: ${( { active } ) => ( active ? '#21c5e5' : '#ffffff' )};
  border: 1px solid  ${( { active } ) => active ? 'white' : '#676c84'};
  box-sizing: border-box;
  border-radius: 16px;
  padding: 8px 16px;
  color: ${( { active } ) => ( active ? 'white' : '#676c84' )};
`

const ModalInline = styled.div`
  display: none;
  @media (max-width: ${StyleGuide.mediaQuery.mobile}) {
    padding-top: 10px;
    display: unset;
    gap: 20px;
    display: flex;
    flex-direction: column;
    .year-buttons {
      display: flex;
      justify-content: space-between;
    }
    .button-100w {
      button {
        width: 100%;
        border-radius: 11px !important;
      }
    }
  }
`

function Filter( { setFilter } ) {
  const [ modal, setModal ] = useState( false )
  const [ status, setStatus ] = useState( null )
  const [ year, setYear ] = useState( moment().format( 'YYYY' ) )
  const [ expanded, setExpanded ] = useState( false )
  const { isMobile } = StyleGuide

  function handleClickFilter() {
    const filter = { 'ano': year, status }
    setFilter( filter )
    setModal( false )
  }

  function handleClickButtonFilter( type ) {
    if ( status === type ) {
      setStatus( null )
    } else {
      setStatus( type )
    }
  }

  function handleOnClickCleanFilter() {
    const filter = { 'ano': null, 'status': null }
    setFilter( filter )
    setYear( moment().format( 'YYYY' ) )
    setStatus( null )
  }

  function contentFilter() {
    return (
      <>
        <span className="title">Ano</span>

        <Select>
          <BlackArrow
            onClick={ () => setYear( moment( year )
              .subtract( 1, 'Y' )
              .format( 'YYYY' ) ) }
          />

          <span className="noselect"> {year} </span>

          <BlackArrow
            onClick={ () => setYear( moment( year )
              .add( 1, 'Y' )
              .format( 'YYYY' ) ) }
          />
        </Select>

        <span className="title">Status</span>

        <div className="year-buttons">
          <Year
            active={ status === 'ESPERA' }
            onClick={ () => handleClickButtonFilter( 'ESPERA' ) }
          >
            Espera
          </Year>

          <Year
            active={ status === 'PAGO' }
            onClick={ () => handleClickButtonFilter( 'PAGO' ) }
          >
            Pago
          </Year>

          <Year
            active={ status === 'ESTORNADO' }
            onClick={ () => handleClickButtonFilter( 'ESTORNADO' ) }
          >
            Estornado
          </Year>
        </div>

        <div className="button-100w">
          <Button onClick={ () => handleClickFilter() }>Filtrar</Button>
        </div>
      </>
    )
  }

  function hadleCLickExpanded() {
    if ( isMobile() ) {
      setExpanded( !expanded )
    } else {
      setModal( !modal )
    }
  }

  return (
    <FilterContainer expanded={ expanded }>
      <div className="background">
        <div
          className="header"
          onClick={ hadleCLickExpanded }
        >
          <div className="svg-filtrar">
            <Search />


            <span>Pesquisar </span>
          </div>

          <div className="arrow">
            <BlackArrow />
          </div>
        </div>

        {expanded ? <ModalInline>{contentFilter()}</ModalInline> : null}
      </div>

      <ModalContainer>
        <Modal
          altura="auto"
          largura="350px"
          onShowModal={ () => setModal( false ) }
          padding
          show={ modal }
        >
          <div className="header">
            <Search />

            <span onClick={ handleOnClickCleanFilter }>Limpar</span>
          </div>

          {contentFilter()}

          <div className="X">
            <XIcon onClick={ () => setModal( false ) } />
          </div>
        </Modal>
      </ModalContainer>
    </FilterContainer>
  )
}

export default Filter
